import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Checkbox, Input } from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createManners, updateManners } from '../../actions/directoryBasicEducation'
import CustomSelect from '../../components/CustomSelect'
import { arrayForSelect } from '../../utils/arrayForSelect'
import { createEduDirection, updateEduDirection } from '../../actions/edu_directions'
import { createVideoConfig, updateVideoConfig } from '../../actions/videoСonfig'

const body = {
  camid: 0,
  rid: 0,
  stream: '',
  description: '',
  ios_url: '',
  rtmp_url: '',
  enabled: 0,
  dnevnik: 0,
  archive_path: '',
  archive_path_include_subdirs: 0,
  archive_files_mask: '',
  archive_username: '',
  archive_password: ''
}

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, addMode }) {

  const dispatch = useDispatch()

  const { list: rooms } = useSelector(state => state.rooms)
  const { videoConfig } = useSelector(state => state.video_config)

  const [auto, setAuto] = useState(false)

  useEffect(() => {
    videoConfig && setAuto(videoConfig?.archive_username ? true : false)
    videoConfig && setValues(videoConfig)
  }, [videoConfig])

  const handleCreate = (values) => {
    dispatch(createVideoConfig(values))
    closeModal()
    resetForm()
  }

  const handleUpdate = (values) => {
    dirty && dispatch(updateVideoConfig(values))
    closeModal()
    resetForm()
  }

  const {
    values,
    errors,
    touched,
    dirty, // проверяет есть ли изменения
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    resetForm
  } = useFormik({
    initialValues: body,
    enableReinitialize: true,
    // validateOnChange: true,
    // validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]
  const onCheckClick = (e) => setFieldValue(e.target.name, Number(!values[e.target.name]))

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >

            <div className={styles.inputsRow}>
              <CustomSelect
                title='Кабинет'
                valuesName="rid"
                value={values.rid}
                options={rooms && arrayForSelect(rooms, 'name', 'rid')}
                width={600}
                setFieldValue={setFieldValue}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Видеопоток'
                name='stream'
                value={values.stream}
                error={error('stream')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Описание'
                name='description'
                value={values.description}
                error={error('description')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='URL потока для iOS'
                name='ios_url'
                value={values.ios_url}
                error={error('ios_url')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='URL потока для RTMP'
                name='rtmp_url'
                value={values.rtmp_url}
                error={error('rtmp_url')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>
            <div className={styles.inputsRow}>
              <Checkbox
                label='Активна'
                name='enabled'
                checked={values?.enabled}
                onClick={onCheckClick}
              />
              <Checkbox
                label='Транслировать в эл.дневник'
                name='dnevnik'
                checked={values?.dnevnik}
                onClick={onCheckClick}
              />
            </div>
          </div>
          <p>Архив</p>
          <hr />
          <div className={styles.inputsRow}>
            <Input
              label='Каталог'
              name='archive_path'
              value={values.archive_path}
              error={error('archive_path')}
              onChange={handleChange}
              style={{ width: '500px' }}
            />
            <Checkbox
              label='Включая подкаталоги'
              name='archive_path_include_subdirs'
              checked={values?.archive_path_include_subdirs}
              onClick={onCheckClick}
              style={{ margin: '20px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Маска файлов'
              name='archive_files_mask'
              value={values.archive_files_mask}
              error={error('archive_files_mask')}
              onChange={handleChange}
              style={{ width: '500px' }}
            />
          </div>

          <div className={styles.inputsRow}>
            <Checkbox
              label='Авторизация'
              name='auto'
              checked={auto}
              onClick={() => setAuto(!auto)}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Пользователь'
              name='archive_username'
              value={values.archive_username}
              error={error('archive_username')}
              onChange={handleChange}
              style={{ width: '500px' }}
              disabled={!auto}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Пароль'
              name='archive_password'
              value={values.archive_password}
              error={error('archive_password')}
              onChange={handleChange}
              style={{ width: '500px' }}
              disabled={!auto}
            />
          </div>


        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal >

  )
}
